import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50 shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950 tracking-tight">
              YOYBUY<span className="text-accent-500">.AUTOS</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.home')}
            </Link>
            <Link to="/yoybuy-sheet-guide" className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.guide')}
            </Link>
            <a href="#categories" className="text-sm text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap">
              {t('nav.categories')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta_buy')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 py-4 px-4 flex flex-col gap-3">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-sm text-foreground-700 hover:text-accent-500 transition-colors py-2">
              {t('nav.home')}
            </Link>
            <Link to="/yoybuy-sheet-guide" onClick={() => setMobileOpen(false)} className="text-sm text-foreground-700 hover:text-accent-500 transition-colors py-2">
              {t('nav.guide')}
            </Link>
            <a href="#categories" onClick={() => setMobileOpen(false)} className="text-sm text-foreground-700 hover:text-accent-500 transition-colors py-2">
              {t('nav.categories')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('hero.cta_buy')}
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}